'use client';
import { store, persistor } from '@flysync/shared-redux/store';
import { Provider as RRProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { useEffect } from 'react';
import Modal from 'react-modal';

export function Provider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Set app element for react-modal accessibility
    // This tells screen readers which element to hide when modal is open
    // Use the body element as the toast portal root.
    if (typeof window !== 'undefined') {
      Modal.setAppElement(document.body);
    }
  }, []);

  return (
    <RRProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {children}
      </PersistGate>
    </RRProvider>
  );
}
